export const SET_ACTIVITY_CHILDREN_LIST = 'SET_ACTIVITY_CHILDREN_LIST';
export const SET_ACTIVITY_ROSTER_INFO = 'SET_ACTIVITY_ROSTER_INFO';
export const SET_ACTIVITY_ROSTER_CHILD = 'SET_ACTIVITY_ROSTER_CHILD';
export const SET_ACTIVITY_ROSTER_REQUIRED_ITEM = 'SET_ACTIVITY_ROSTER_REQUIRED_ITEM';
export const TOGGLE_ACTIVITY_DROP_IN_PAGE = 'TOGGLE_ACTIVITY_DROP_IN_PAGE';
export const SET_ACTIVITY_ADDONS = 'SET_ACTIVITY_ADDONS';
export const SET_ACTIVITIES_DROP_IN_DATES = 'SET_ACTIVITIES_DROP_IN_DATES';
export const SET_WAITLIST_AVAILABLE = 'SET_WAITLIST_AVAILABLE';
export const SET_AFTER_CARE_AVAILABLE_WAITLIST_DAYS = 'SET_AFTER_CARE_AVAILABLE_WAITLIST_DAYS';



// WEBPACK FOOTER //
// ./src/store/modules/activity-children-list/mutations.js